// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Content_Receivables($where: vaxiom_receivables_bool_exp!, $order: order_by!) {
  vaxiom_receivables(where: $where, order_by: { due_date: $order }) {
    id
    rtype
    status
    due_date
    amount
    balance_amount
    human_readable_id
    sys_created
    treatment {
      id
      name
    }
    payment_account {
      id
      account_type
      person_payment_account {
        id
        payer_person {
          id
          first_name
          last_name
        }
      }
      insurance_payment_account {
        id
        insurance_company {
          id
          carrier_name
        }
      }
    }
    transactions(order_by: { sys_created: asc }) {
      id
      dtype
      amount
      sys_created
      notes
    }
  }
}

`